import PageWrapper from '@/components/atoms/PageWrapper';
import { NavigationBarBreadCrumbs } from "@/components/molecules/BackNav";
import { HomePageOrganizationRow } from '@/components/molecules/HomePageOrganizationRow';
import { ScrollArea } from "@/components/ui/scroll-area";
import { Spinner } from '@/components/ui/spinner';
import { TutorialCard } from '@/features/help/components/organisms/TutorialCard';
import { HOMEPAGE_TUTORIALS } from '@/features/help/constants/tutorials';
import { useGetOrganizations } from "@/features/organization/hooks/useQuery/useGetOrganizations";
import { useUserData } from "@/lib/useQuery/user/useUserData";
import { useUserStore } from "@/lib/zustand/useStore";
import { CircleHelp, UsersRound } from "lucide-react";

export default function HomePage() {
    const { data: user } = useUserData();
    const { session } = useUserStore();
    const { data: organizationData, isLoading: isLoadingGetOrganizations } = useGetOrganizations({ isEnabled: !!session });

    const getCurrentDate = () => {
        const date = new Date();
        const options: Intl.DateTimeFormatOptions = { weekday: 'long', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }

    return (
        <PageWrapper>
            <div className="flex flex-col gap-5 grow">
                <NavigationBarBreadCrumbs.Set
                    currentPageName={"Home"}
                />
                <div className="flex items-end justify-between">
                    <h2 className="text-2xl font-semibold">Hello{user?.first_name ? ", " : ""} {user?.first_name || ""}</h2>
                    <p className="text-sm font-semibold">{getCurrentDate()}</p>
                </div>

                <div className="flex flex-col flex-wrap h-full gap-3 grow md:flex-row">
                    <div className="flex-1 min-w-[300px] overflow-hidden break-words">
                        <div className="bg-sidebar border border-gray-300 rounded-lg p-4 flex flex-col gap-3 w-full h-[400px]">
                            <div className="flex items-center gap-1">
                                <CircleHelp size="16" />
                                <h3 className="font-semibold">Getting Started</h3>
                            </div>

                            <ScrollArea className="pe-3" type="always">
                                <div className="flex flex-col gap-2 px-1">
                                    {HOMEPAGE_TUTORIALS.map((tutorial) => (
                                        <TutorialCard
                                            key={tutorial.title}
                                            {...tutorial}
                                        />
                                    ))}
                                </div>
                            </ScrollArea>

                        </div>
                    </div>
                    <div className="flex-1 min-w-[300px] overflow-hidden break-words">
                        <div className="bg-sidebar border border-gray-300 rounded-lg p-4 flex flex-col gap-3 w-full h-[400px]">
                            {isLoadingGetOrganizations ? (
                                <div className="flex items-center justify-center w-full h-full">
                                    <Spinner />
                                </div>
                            ) : (
                                <>
                                    <div>
                                        <div className="flex items-center gap-1">
                                            <UsersRound size="16" />
                                            <h3 className="font-semibold">Organizations</h3>
                                        </div>
                                        <div className="text-xs">You are Affiliated with {organizationData?.length || 0} Organizations</div>
                                    </div>

                                    <ScrollArea className="pe-3" type="always">
                                        <div className="flex flex-col gap-2 px-1">

                                            {organizationData?.map((org) => (
                                                <HomePageOrganizationRow
                                                    key={org.id}
                                                    org={org}
                                                />
                                            ))}

                                        </div>
                                    </ScrollArea>
                                </>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </PageWrapper>
    );
}
